import { createSlice } from "@reduxjs/toolkit";
import { authInitialState } from "../initialState";

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    requestStart: function(state) {
      state.loading = true;
      state.error = null;
    },
    loadUser: function(state, action) {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    logOut: function(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.loading = false;
      state.error = null;
    },
    resetAuth: function(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.loading = false;
      state.error = null;
    },
    requestFail: function(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: function(state) {
      state.error = null;
    },
  },
});

export default authSlice.reducer;
export const authActions = authSlice.actions;